import { render, staticRenderFns } from "./ToyRentTransferModalForm.vue?vue&type=template&id=087e836a&"
import script from "./ToyRentTransferModalForm.vue?vue&type=script&lang=js&"
export * from "./ToyRentTransferModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports